import React from 'react'
import { withRouter, Link} from 'react-router-dom';
import { inject, observer } from "mobx-react";
import Language from '../language/language'
import { $const } from '../../helper'
import Modal from '../modal/modal'
import { Button } from 'antd'

import './stylesheets/applyTeamSuccess.scss'



@inject('teamStore', 'languageStore', 'authStore', 'navStore')
@withRouter
@observer
export default class ApplyTeamSuccess extends React.Component {
  state = {
    showNotice: false
  }
  cancelApply = () => {
    const applicationTeamInfo = this.props.teamStore.applicationTeamInfo
    this.props.teamStore.updateTeamMemberApplication({
      variables: {
        input: {
          id: applicationTeamInfo.gappliction.id,
          attributes: {
            teamId: applicationTeamInfo.gappliction.teamId,
            memberId: (this.props.authStore.user.id).toString().id,
            eventRoleId: applicationTeamInfo.eventRoleId,
            eventPositionId: applicationTeamInfo.eventPositionId,
            status: $const.TEAM_APPLICATION_STATUS.CANCEL
          }
        }
      }
    }, true).finally(() => {
      this.props.history.push('/registration-center')
    })
  }
  cancelClick = () => {
    this.setState({
      showNotice: true
    })
  }
  close = () => {
    this.setState({
      showNotice: false
    })
  }
  handleToCenter = () => {
    this.props.navStore.changeNavigation("/control-center")
  }

  handleToIndex = () => {
    this.props.navStore.changeNavigation("/registration-center")
  }

  render () {
    
    if (!this.props.teamStore.joinInTeamInfo || !this.props.teamStore.joinInTeamInfo.id) {
      return <div className="apply-team-success"></div>
    }
    if (!this.props.teamStore.applicationTeamInfo || !this.props.teamStore.applicationTeamInfo.gappliction) {
      return <div className="apply-team-success"></div>
    }
    const team = this.props.teamStore.joinInTeamInfo 
    const lang = this.props.languageStore.lang
    return (
      <div className="apply-team-success">
        <div className="title">
          <Language resource="APPLY_SUCCESS" />
        </div>
        <div className="sub-title">
          <Language resource="YOUR_APPLY" />
        </div>
        <div className="team-name">
          {`${team.collegeName || (team.college && team.college.name)}${team.name}`}
          <Language resource="TEAM" />
        </div>
        {lang === 'zh'
          ?
            <div className="sub-title">
              <Language resource="YOU_CAN" />
              <Link onClick={this.handleToCenter} to="/control-center">
                {' '}<Language resource="CONTROL_CENTER" />{' '}
              </Link>
              <Language resource="VIEW_PROCESS" />
              <Language resource="YOUR_ALSO" />
              <div className="spe-link" onClick={this.cancelClick}>
                {' '}<Language resource="CANCEL_APPLY" />{' '}
              </div>
            </div>
          :
            <div className="sub-title">
              <Language resource="YOU_CAN" />
              <div className="spe-link" onClick={this.cancelClick}>
                {' '}<Language resource="CANCEL_APPLY" />{' '}
              </div>
              <Language resource="YOUR_ALSO" />
              <Link onClick={this.handleToCenter} to="/control-center">
                {' '}<Language resource="CONTROL_CENTER" />{' '}
              </Link>
            </div>
        }
        
        <Link onClick={this.handleToIndex} to="/registration-center" ><Language resource="RETURN_REGISTRATION_CENTER" /></Link>
        <Modal  title={<Language resource="COMFIRM_CANCEL" />} width={457} state={this.state.showNotice} close={this.close}>
          <div className="sub-title">
            <Language resource="COMFIRM_CANCEL_DETAIL">
            </Language>
          </div>
          <div className="operate">
            <Button onClick={this.cancelApply}>
              <Language resource="CONFIRM" />
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/applyTeam/applyTeamSuccess.js